import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = ({ style, width = "20", height = "20" }) => (
  <svg
    style={style}
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_30838_3087)">
      <path
        d="M4.79102 3.26004C4.26097 3.26028 3.83008 3.69179 3.83008 4.22195V5.04129H3.01172C2.48117 5.04129 2.04883 5.47227 2.04883 6.00223V14.1712C2.04883 14.7017 2.48111 15.1341 3.01172 15.1341H7.60156L7.60547 15.0882L7.66406 14.469L7.66895 14.4143H3.01172C2.87799 14.4143 2.76855 14.3048 2.76855 14.1712V6.00223C2.76855 5.86944 2.8778 5.76004 3.01172 5.76004H3.83008V12.3919C3.83026 12.9219 4.26108 13.3526 4.79102 13.3528H7.71973L7.73145 13.3216L7.97168 12.7014L7.99805 12.6331H4.79102C4.65799 12.6328 4.54999 12.525 4.5498 12.3919V4.22195C4.5498 4.08868 4.65787 3.98001 4.79102 3.97977H9.52441V5.11649C9.52441 5.6467 9.95524 6.07824 10.4854 6.0784H11.624V8.03348L11.6924 8.00711L12.3115 7.76785L12.3438 7.75516V5.71902C12.3438 5.62358 12.3057 5.53161 12.2383 5.46414L10.1387 3.36551C10.0712 3.29803 9.97922 3.26004 9.88379 3.26004H4.79102ZM11.1143 5.35867H10.4854C10.3521 5.35851 10.2441 5.24981 10.2441 5.11649V4.48856L11.1143 5.35867Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.1"
      />
      <path
        d="M6.30634 5.63211C6.10771 5.63215 5.9471 5.79288 5.94696 5.99149C5.94696 6.19021 6.10762 6.3518 6.30634 6.35184H8.50262C8.70125 6.35169 8.862 6.19015 8.862 5.99149C8.86186 5.79295 8.70116 5.63225 8.50262 5.63211H6.30634Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.1"
      />
      <path
        d="M6.30963 7.9502C6.11107 7.95031 5.9504 8.11101 5.95026 8.30957C5.95026 8.50825 6.11098 8.66981 6.30963 8.66992H9.87115C10.0698 8.66978 10.2305 8.50823 10.2305 8.30957C10.2304 8.11103 10.0697 7.95034 9.87115 7.9502H6.30963Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.1"
      />
      <path
        d="M6.30957 9.9502C6.11104 9.95035 5.95034 10.111 5.9502 10.3096C5.9502 10.5082 6.11095 10.6698 6.30957 10.6699H8.70508L8.71973 10.6426L9.04395 10.0234L9.08301 9.9502H6.30957Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.1"
      />
    </g>
    <path
      d="M14.971 9.14792C15.5804 8.53868 16.5716 8.53855 17.181 9.14792C17.4758 9.44291 17.6379 9.83533 17.638 10.2524C17.638 10.6697 17.476 11.0628 17.181 11.3579C16.8763 11.6626 16.4755 11.8149 16.0755 11.8149C15.6755 11.8149 15.2757 11.6624 14.971 11.3579C14.6759 11.0628 14.513 10.6698 14.513 10.2524C14.5131 9.83522 14.676 9.44293 14.971 9.14792ZM16.0755 9.39597C15.8558 9.39599 15.6362 9.4789 15.4691 9.64597C15.3071 9.80793 15.2182 10.0234 15.2181 10.2524C15.2181 10.4815 15.3071 10.6968 15.4691 10.8589C15.8034 11.1932 16.3476 11.1932 16.6819 10.8589C16.8439 10.6968 16.9329 10.4815 16.9329 10.2524C16.9328 10.0234 16.8439 9.80794 16.6819 9.64597C16.5148 9.47895 16.2952 9.39597 16.0755 9.39597Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.1"
    />
    <path
      d="M18.5596 6.96191C18.9953 6.98569 19.3415 7.33283 19.3652 7.76855C19.4106 8.6005 19.3675 10.2309 18.5605 11.791C18.1486 12.5874 17.4506 13.4277 16.6475 14.0977C16.6432 14.1012 16.6383 14.1047 16.6338 14.1084L16.5195 15.5996C16.4991 15.8639 16.3598 16.0999 16.1387 16.2461L14.5781 17.2773C14.4777 17.3438 14.3624 17.3779 14.2461 17.3779C14.1634 17.3779 14.0803 17.3608 14.002 17.3262C13.8133 17.2427 13.6811 17.071 13.6494 16.8672L13.459 15.6426C13.4512 15.6439 13.4433 15.6462 13.4355 15.6475C13.3895 15.6551 13.3428 15.6592 13.2969 15.6592C13.0734 15.6591 12.8556 15.5695 12.6943 15.4082L10.9189 13.6338C10.7244 13.4392 10.6356 13.1614 10.6807 12.8916C10.6821 12.8832 10.6831 12.8746 10.6846 12.8662L9.46094 12.6777C9.25713 12.6461 9.08545 12.5148 9.00195 12.3262C8.91847 12.1375 8.93696 11.9212 9.05078 11.749L10.082 10.1885C10.2282 9.96744 10.4642 9.82902 10.7285 9.80859L12.2188 9.69238C12.2224 9.68789 12.2269 9.68395 12.2305 9.67969C12.9004 8.87651 13.7407 8.17955 14.5371 7.76758C16.0973 6.96058 17.7276 6.91647 18.5596 6.96191ZM15.8848 14.6602C15.3248 15.0244 14.7397 15.2998 14.1475 15.4785L14.3213 16.6006L15.75 15.6572C15.7885 15.6317 15.8129 15.591 15.8164 15.5449L15.8848 14.6602ZM11.584 12.1934C11.4955 12.4516 11.4236 12.7242 11.376 13.0088C11.3687 13.0534 11.3839 13.1006 11.418 13.1348L13.1934 14.9102C13.2275 14.9441 13.2746 14.9595 13.3193 14.9521C13.5516 14.9133 13.8265 14.847 14.1328 14.7422L11.584 12.1934ZM18.5215 7.66602C17.7593 7.62452 16.2715 7.66422 14.8613 8.39355C14.1475 8.76275 13.3857 9.39662 12.7725 10.1318C12.4844 10.4772 12.1523 10.9378 11.8779 11.4902L14.8369 14.4482C15.2619 14.2379 15.7225 13.9509 16.1963 13.5557C16.9314 12.9425 17.5644 12.1805 17.9336 11.4668C18.663 10.0566 18.7027 8.5689 18.6611 7.80664C18.657 7.73081 18.5973 7.67029 18.5215 7.66602ZM10.7832 10.5117C10.7371 10.5153 10.6954 10.5396 10.6699 10.5781L9.72559 12.0059L10.8486 12.1787C11.0274 11.5869 11.303 11.002 11.667 10.4424L10.7832 10.5117Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.1"
    />
    <path
      d="M10.0481 13.9716C10.1858 13.8339 10.4094 13.8339 10.5471 13.9716C10.6844 14.1093 10.6845 14.3321 10.5471 14.4697L9.55884 15.4579C9.49008 15.5266 9.39982 15.5604 9.30981 15.5605C9.21982 15.5605 9.12956 15.5265 9.06079 15.4579C8.9231 15.3202 8.9231 15.0966 9.06079 14.9589L10.0481 13.9716Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.1"
    />
    <path
      d="M10.9532 14.8768C11.0909 14.7391 11.3145 14.7391 11.4522 14.8768C11.5896 15.0145 11.5897 15.2372 11.4522 15.3749L9.5528 17.2743C9.48403 17.343 9.39383 17.3777 9.30377 17.3778C9.21372 17.3778 9.12356 17.343 9.05475 17.2743C8.91706 17.1366 8.91706 16.9129 9.05475 16.7753L10.9532 14.8768Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.1"
    />
    <path
      d="M11.8585 15.782C11.9962 15.6443 12.2199 15.6443 12.3575 15.782C12.4948 15.9197 12.4949 16.1425 12.3575 16.2801L11.3693 17.2683C11.3005 17.337 11.2102 17.3708 11.1202 17.3709C11.0303 17.3709 10.94 17.3369 10.8712 17.2683C10.7335 17.1306 10.7335 16.907 10.8712 16.7693L11.8585 15.782Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.1"
    />
    <defs>
      <clipPath id="clip0_30838_3087">
        <rect
          width="12.3934"
          height="12.3935"
          fill="white"
          transform="matrix(-1 0 0 1 13.3933 3)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SVG;
